import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/preferred-relationships/profile/loading';

export const Route = createFileRoute('/_private/settings/preferred-relationships/$id')({
  pendingComponent: Loading,
});
